import React from 'react';
import { ShieldAlert } from 'lucide-react';
import Logo from './Logo';
import { SITE, SOCIALS } from '../mock';

export default function Footer() {
  return (
    <footer className="relative border-t border-[var(--ar-border)] py-12 mt-10 overflow-hidden">
      <img src="/assets/roobet-word-cyan.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute right-[-40px] bottom-[-30px] w-[420px] max-w-[70%] opacity-[0.04]" />
      <div className="ar-container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <Logo size={44} />
            <span className="font-display font-bold text-xl">ASIAN<span className="text-cyan">RISK</span></span>
          </div>
          <div className="flex items-center gap-6 text-sm font-tech tracking-wider">
            <a href="#rewards" className="text-muted hover:text-cyan transition-colors">REWARDS</a>
            <a href="#leaderboard" className="text-muted hover:text-cyan transition-colors">LEADERBOARD</a>
            <a href={SOCIALS.beacons} target="_blank" rel="noopener noreferrer" className="text-muted hover:text-cyan transition-colors">BEACONS</a>
          </div>
          <a href={SITE.roobetRef} target="_blank" rel="noopener noreferrer" className="btn-gold !py-2.5 !px-5"><img src="/assets/roobet-chip-white.png" alt="" aria-hidden="true" className="h-5 w-5 object-contain" /> OPEN ROOBET</a>
        </div>

        <div className="ar-divider my-8" />

        {/* Responsible gambling / compliance bar */}
        <div className="ar-panel p-5 mb-6 flex flex-col md:flex-row items-center justify-center gap-5 text-center md:text-left">
          <div className="flex items-center gap-3 flex-shrink-0">
            <span className="inline-flex items-center justify-center w-11 h-11 rounded-full font-display font-bold text-sm flex-shrink-0" style={{ border: '2px solid #ff5c5c', color: '#ff7b7b', boxShadow: '0 0 16px -4px rgba(255,92,92,0.5)' }}>18+</span>
            <ShieldAlert size={22} className="text-gold flex-shrink-0" />
          </div>
          <p className="text-xs text-muted leading-relaxed">
            Gambling can be addictive — please play responsibly and only bet what you can afford to lose. You must be of legal age in your jurisdiction (18+/21+). For free, confidential support visit{' '}
            <a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer" className="text-cyan hover:underline">BeGambleAware.org</a>,{' '}
            <a href="https://www.gamblingtherapy.org/" target="_blank" rel="noopener noreferrer" className="text-cyan hover:underline">GamblingTherapy.org</a>, or call a helpline such as{' '}
            <span className="text-foreground">1-800-522-4700</span> (US).
          </p>
        </div>

        <div className="text-center space-y-3">
          <p className="text-xs text-muted max-w-3xl mx-auto leading-relaxed">
            AsianRisk is an independent content creator and official Roobet affiliate. This site is for entertainment only and does not accept wagers. Gambling involves risk — never chase losses and set your own limits.
          </p>
          <p className="text-xs text-muted">© {new Date().getFullYear()} ASIANRISK. All rights reserved. Not affiliated with or endorsed beyond the Roobet affiliate program.</p>
        </div>
      </div>
    </footer>
  );
}
